"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var listing_sidebar_csp_card_1 = require("./listing_sidebar_csp_card");
var ListingSidebarCSP = /** @class */ (function (_super) {
    tslib_1.__extends(ListingSidebarCSP, _super);
    function ListingSidebarCSP() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingSidebarCSP.prototype.render = function () {
        if (!this.props.data.loading && !this.props.data.csp)
            return null;
        return (React.createElement("div", null,
            React.createElement("h4", { className: "weight-bold mb-half" }, I18n.t('discovery.comparisonShoppingPages.listingSidebar.findMore')),
            React.createElement(listing_sidebar_csp_card_1.default, { csp: this.props.data.csp })));
    };
    return ListingSidebarCSP;
}(React.Component));
exports.ListingSidebarCSP = ListingSidebarCSP;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Core_Listing_CspCard(\n      $id: String\n    ){\n      csp(input: { id: $id }) {\n        id\n        title\n        reviews {\n          total\n          avgRating\n        }\n        webLink {\n          href\n        }\n        image(input: { transform:\"large\"}) {\n          source\n        }\n        inventory {\n          newLowPrice {\n            amountCents\n            display\n          }\n          usedLowPrice {\n            amountCents\n            display\n          }\n        }\n      }\n    }\n  "], ["\n    query Core_Listing_CspCard(\n      $id: String\n    ){\n      csp(input: { id: $id }) {\n        id\n        title\n        reviews {\n          total\n          avgRating\n        }\n        webLink {\n          href\n        }\n        image(input: { transform:\"large\"}) {\n          source\n        }\n        inventory {\n          newLowPrice {\n            amountCents\n            display\n          }\n          usedLowPrice {\n            amountCents\n            display\n          }\n        }\n      }\n    }\n  "]))), {
    options: function (ownProps) { return ({
        variables: {
            id: ownProps.cspId,
        },
    }); },
});
exports.default = connect(ListingSidebarCSP);
var templateObject_1;
//# sourceMappingURL=listing_sidebar_csp.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/listing_sidebar_csp.js
// module id = YqQn
// module chunks = 20 21